import React from 'react';
import tick from '@images/tick.svg?url';

import * as style from './QuizRowStyle.module.scss'

type Props = {
  label: string;
  isSigned: boolean;
  handleShowQuizClick: any;
};

export const QuizRow = ({
  label,
  isSigned,
  handleShowQuizClick,
}: Props) => {


  const quizActions = () => {
    if (isSigned) return <img src={tick} className={style.tick} />;

    return (
      <button
        className={style.completeQuiz}
        onClick={handleShowQuizClick}
      >
        Click to complete
      </button>
    );
  };

  return (
    <div className={style.quiz}>
      <div className={style.quizSection}>
        <span className={style.quizName}>{label}</span>
          {quizActions()}
      </div>
    </div>
  );
};
